import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';
import { Roteador } from '@/app/Roteador';
import { DialogosProvider } from '@/shared/ui/DialogosProvider';
import { OcultarValoresProvider } from '@/shared/state/OcultarValoresContext';
import { TemaProvider } from '@/shared/state/TemaContext';
import '@/styles/global.css';

/**
 * Entrada do app web. É deliberadamente igual à do desktop
 * (`src/main.tsx`): a única diferença entre os alvos é qual implementação
 * de `src/platform/` o build escolhe. Se você precisar mudar a árvore de
 * providers aqui, mude no desktop também.
 */

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root não encontrado.');

// 100vh no celular considera a barra do navegador e corta o rodapé. Esta
// variável dá a altura real da janela; o CSS usa `var(--altura-viewport)`
// onde `100vh` não serve. Navegadores com `dvh` nem precisam, mas manter
// a variável evita bifurcar o CSS entre os dois alvos.
function ajustarAlturaViewport(): void {
  document.documentElement.style.setProperty(
    '--altura-viewport',
    `${window.innerHeight}px`,
  );
}
ajustarAlturaViewport();
window.addEventListener('resize', ajustarAlturaViewport);
window.addEventListener('orientationchange', ajustarAlturaViewport);

createRoot(container).render(
  <StrictMode>
    <TemaProvider>
      <DialogosProvider>
        <OcultarValoresProvider>
          <Roteador>
            <App />
          </Roteador>
        </OcultarValoresProvider>
      </DialogosProvider>
    </TemaProvider>
  </StrictMode>,
);
